export default __webpack_public_path__ + "static/media/privatecar-banner.568ad559.png";